import React from 'react';
import styled from 'styled-components';
import colors from 'globals/colors';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 60px;
  align-items: center;
  svg {
    height: 60px;
    width: 60px;
    padding: 5px;
  }
`;

export default class Loader extends React.Component {
  state = {
    showLoader: false
  };
  async componentDidMount() {
    await new Promise(r => setTimeout(r, 500));
    if (!this.mountCheck) {
      return;
    }
    this.setState({showLoader: true});
  }
  render() {
    return (
      <Wrapper ref={e => (this.mountCheck = e)} data-testid='loader'>
        {this.state.showLoader && (
          <svg
            width='38'
            height='38'
            viewBox='0 0 38 38'
            xmlns='http://www.w3.org/2000/svg'
          >
            <defs>
              <linearGradient
                x1='8.042%'
                y1='0%'
                x2='65.682%'
                y2='23.865%'
                id='a'
              >
                <stop stopColor={colors.theme} stopOpacity='0' offset='0%' />
                <stop
                  stopColor={colors.theme}
                  stopOpacity='.631'
                  offset='63.146%'
                />
                <stop stopColor={colors.theme} offset='100%' />
              </linearGradient>
            </defs>
            <g fill='none' fillRule='evenodd'>
              <g transform='translate(1 1)'>
                <path
                  d='M36 18c0-9.94-8.06-18-18-18'
                  id='Oval-2'
                  stroke='url(#a)'
                  strokeWidth='2'
                >
                  <animateTransform
                    attributeName='transform'
                    type='rotate'
                    from='0 18 18'
                    to='360 18 18'
                    dur='0.9s'
                    repeatCount='indefinite'
                  />
                </path>
                <circle fill={colors.theme} cx='36' cy='18' r='1'>
                  <animateTransform
                    attributeName='transform'
                    type='rotate'
                    from='0 18 18'
                    to='360 18 18'
                    dur='0.9s'
                    repeatCount='indefinite'
                  />
                </circle>
              </g>
            </g>
          </svg>
        )}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loader/index.js